"use client";

import Image from "next/image";
import { Icon } from "@iconify/react";
import { useState } from "react";
import Lightbox from "../Shared/Lightbox";

export default function ProductAccessories({
  accessories,
}: {
  accessories: { accName: string; accImage: string }[];
}) {
  const [selected, setSelected] = useState<string | null>(null);
  if (!accessories || accessories.length === 0)
    return <div className="text-muted italic">No accessories listed.</div>;

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {accessories.map((a, i) => (
          <div
            key={i}
            onClick={() => setSelected(a.accImage)}
            className="group relative aspect-square bg-gray-50 dark:bg-white/5 rounded-2xl overflow-hidden cursor-pointer border border-border dark:border-white/10 hover:border-primary/50 transition-all"
          >
            <Image
              src={a.accImage}
              alt={a.accName}
              fill
              className="object-contain group-hover:scale-110 transition-transform duration-500 p-5"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col gap-3 items-center justify-center">
              <Icon icon="ion:expand-outline" className="text-white text-3xl" />
              <h3 className="text-white font-medium px-2 text-center">
                {a.accName}
              </h3>
            </div>
          </div>
        ))}
      </div>

      <Lightbox src={selected} onClose={() => setSelected(null)} />
    </>
  );
}
